export const CanvasPagesDropdown = {
  extends: ['CanvasButton', 'DropdownParentFocus', 'Button'],
  Text: {
    lineHeight: 0.9,
    width: 'D',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    text: (el) =>
      el.call('getActiveCanvasPage') || el.call('polyglot', 'editor.chooseCanvas.default'),
    onMouseover: (ev, el, s) => {
      if (!s.hover) {
        s.hover = true
        el.call('setNavbarTooltipPosition', {
          visible: true
        })
      }
    },
    onMouseleave: (ev, el, s) => {
      if (s.hover) {
        s.hover = false
        const Tooltip = el.lookup('NavbarTooltip')
        if (Tooltip) {
          Tooltip.update({
            opacity: '0',
            visibility: 'hidden'
          })
        }
      }
    },
    title: (el) => el.call('polyglot', 'editor.chooseCanvas.selected')
  },
  Dropdown: {
    left: '0',
    ChooseCanvas: {
      padding: 'X'
    }
  },
  DropdownArrow: {},
  padding: 'Y2 Y2 Y2 Z2',
  align: 'center',
  gap: 'Y',
  aspectRatio: 'none'
}
